"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../index");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const Integration_1 = require("../integrations/Integration");
const auth_1 = require("../auth");
const FeatureFlags_1 = require("./FeatureFlags");
let AppSettings = class AppSettings {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID),
    typeorm_1.PrimaryGeneratedColumn(),
    tslib_1.__metadata("design:type", Number)
], AppSettings.prototype, "id", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User, { nullable: true }),
    typeorm_1.OneToOne(() => auth_1.User, {
        cascade: false,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], AppSettings.prototype, "appUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Integration_1.Integration, { nullable: true }),
    typeorm_1.OneToOne(() => Integration_1.Integration, {
        cascade: false,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], AppSettings.prototype, "appEmailServiceProvider", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "allowSignups", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "enableMagicLinks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "allowUsersToCreateWorkspaces", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "requireWorkspacesToHavePaymentMethod", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "removeHideablesOnCampaignSend", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "removeOsysTagsOnCampaignSend", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    typeorm_1.Column({ default: false }),
    tslib_1.__metadata("design:type", Boolean)
], AppSettings.prototype, "minifyOnCampaignSend", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON),
    typeorm_1.Column({
        default: {},
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Object)
], AppSettings.prototype, "minifySettings", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => FeatureFlags_1.FeatureFlags),
    typeorm_1.Column({
        default: new FeatureFlags_1.FeatureFlags(),
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", FeatureFlags_1.FeatureFlags)
], AppSettings.prototype, "featureFlagOverrides", void 0);
AppSettings = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], AppSettings);
exports.AppSettings = AppSettings;
//# sourceMappingURL=AppSettings.js.map